import { makeActionCreator } from '../../config/store/utils'
import theme from '../../config/styles/theme'
import { getBuyersTradedAmountsMonthly, getBuyersTradedAmountsYearly } from '../../services/buyers'

const MONTHS_DICTIONARY = {
  Ene: 'Enero',
  Feb: 'Febrero',
  Mar: 'Marzo',
  Abr: 'Abril',
  May: 'Mayo',
  Jun: 'Junio',
  Jul: 'Julio',
  Ago: 'Agosto',
  Sep: 'Septiembre',
  Oct: 'Octubre',
  Nov: 'Noviembre',
  Dic: 'Diciembre'
}

export const GET_BUYERS_TRADED_AMOUNTS = 'GET_BUYERS_TRADED_AMOUNTS'
export const GET_BUYERS_TRADED_AMOUNTS_ERROR = 'GET_BUYERS_TRADED_AMOUNTS_ERROR'
export const GET_BUYERS_TRADED_AMOUNTS_SUCCESS = 'GET_BUYERS_TRADED_AMOUNTS_SUCCESS'
export const onGetBuyersTradedAmounts = makeActionCreator(GET_BUYERS_TRADED_AMOUNTS)
export const onGetBuyersTradedAmountsError = makeActionCreator(GET_BUYERS_TRADED_AMOUNTS_ERROR, 'payload')
export const onGetBuyersTradedAmountsSuccess = makeActionCreator(GET_BUYERS_TRADED_AMOUNTS_SUCCESS, 'payload')
export const onGetBuyersTradedAmountsThunk = payload => async dispatch => {
  dispatch(onGetBuyersTradedAmounts())

  try {
    const [{ data: monthlyData }, { data: yearlyData }] = await Promise.all([
      getBuyersTradedAmountsMonthly({
        mechanismId: payload.mechanismId,
        sectorsIds: payload.sectorsIds,
        year: payload.year
      }),
      getBuyersTradedAmountsYearly({
        mechanismId: payload.mechanismId,
        sectorsIds: payload.sectorsIds,
        year: payload.year
      })
    ])
    const enhancedData = payload.sectorsIds.reduce((collection, sectorId) => {
      const dataByMonth = monthlyData.payload.filter(item => item.idSector === sectorId) || []
      const dataByYear = yearlyData.payload.filter(item => item.idSector === sectorId) || []
      const [firstRow] = dataByMonth
      // FIXME: Gets color name from a fixed source.
      const colorName = Object.keys(theme.palette.charts)[window.Math.floor(window.Math.random() * 30)]

      if (!firstRow) {
        return collection
      }

      return collection.concat({
        amountMonthlyCLP: dataByMonth.map(item => item.amountCLPSectorMonth),
        amountMonthlyUSD: dataByMonth.map(item => item.amountUSDSectorMonth),
        amountYearlyCLP: dataByYear.map(item => item.amountCLPSector),
        amountYearlyUSD: dataByYear.map(item => item.amountUSDSector),
        color: theme.palette.charts[colorName],
        mechanism: firstRow.modalidad,
        month: dataByMonth.map(item => MONTHS_DICTIONARY[item.month]),
        name: firstRow.sector,
        percentageMonthly: dataByMonth.map(item => item.percentageSectorMonth),
        percentageYearly: dataByYear.map(item => item.percentageSector)
      })
    }, [])
    const csv = [
      ['Año', 'Sector', 'Mes', 'Mecanismo de compra', 'Monto transado', 'Monto transado (USD)'],
      ...enhancedData.reduce((collection, item) => {
        const row = item.month.map((month, index) => [
          payload.year,
          item.name,
          month,
          item.mechanism,
          item.amountMonthlyCLP[index],
          item.amountMonthlyUSD[index]
        ])

        return [...collection, ...row]
      }, [])
    ]

    return dispatch(onGetBuyersTradedAmountsSuccess({ csv, data: enhancedData }))
  } catch (error) {
    return dispatch(onGetBuyersTradedAmountsError({ error }))
  }
}
